import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { BASIC_SCHEMA_FIELDS } from '../basics';
import { buttonSchemaFields } from '../basics/button-fields.schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the newsletter component form.
 * Defines the frontend-controlled visual fields. The subscription settings
 * (newsletter group, double opt-in, hidden fields, captcha, mail template) are
 * provided by the backend designer dialog and therefore not listed here.
 */
export const NEWSLETTER_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttons',
      label: 'components.newsletter.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
